import React, { useState } from "react";
import { Download, Loader2, PlayCircle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const TutorialPlayer = ({ embedUrl, title, testId }) => (
  <div className="aspect-video w-full overflow-hidden rounded-xl bg-[#0B3D1F]" data-testid={`${testId}-container`}>
    {embedUrl ? (
      <iframe src={embedUrl} title={title} className="h-full w-full border-0" data-testid={testId}
        loading="lazy" referrerPolicy="strict-origin-when-cross-origin"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen />
    ) : (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center text-white/80" data-testid={`${testId}-empty`}>
        <PlayCircle className="h-10 w-10 text-[#F2C94C]" aria-hidden="true" />
        <p className="text-sm">Video tutorial akan segera tersedia.</p>
      </div>
    )}
  </div>
);

export const GuideDownloadButton = ({ guide, testId, className = "" }) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const download = async () => {
    setDownloading(true);
    setError("");
    try {
      const response = await api.get("/site/tutorial/guide", { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement("a");
      const name = response.headers["content-disposition"]?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
      anchor.href = url;
      anchor.download = name ? decodeURIComponent(name) : guide.filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch {
      setError("Panduan belum dapat diunduh. Silakan coba lagi.");
    } finally { setDownloading(false); }
  };
  return <div>
    <Button onClick={download} disabled={!guide || downloading} data-testid={testId} className={`h-11 rounded-xl font-bold ${className}`}>
      {downloading ? <Loader2 className="animate-spin" /> : <Download />}
      {downloading ? "Mengunduh..." : "Unduh Buku Panduan"}
    </Button>
    {error && <p role="alert" data-testid={`${testId}-error`} className="mt-3 rounded-lg bg-red-50 p-3 text-sm text-red-800">{error}</p>}
  </div>;
};
